
import LineInfo from '@/interfaces/line-info'
import { getSeparatedPhoneNumber } from '@/helpers/formatter'
import { Prop } from 'vue-property-decorator'
import { Vue, Options } from 'vue-class-component'
import ClubcardOnline from '@/components/clubcard-online/clubcard-online.vue'
import ClubcardLoyalty from '@/components/clubcard-loyalty/clubcard-loyalty.vue'
import CustomerInfo from '@/interfaces/customer-info'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useStore } from '@/store'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'

library.add(faChevronRight)

@Options({
  components: {
    ClubcardOnline,
    ClubcardLoyalty,
    FontAwesomeIcon
  }
})
export default class AccountInfo extends Vue {
  @Prop() openModalUnlinkConfirmation!: void
  @Prop() forceUpdate!: boolean
  @Prop() openModalBarcode!: void
  store = useStore()

  get customer(): CustomerInfo {
    return this.store.state.customer
  } 

  get lineInfo(): LineInfo {
    return this.store.state.lineInfo
  } 

  getSeparatedPhoneNumber () {
    const mobile = this.store.state.customer.phoneNumber!
    return getSeparatedPhoneNumber(mobile)
  }

  openModalEditProfile() {
    this.store.dispatch('modalEditProfile/onOpen')
    addGAEvent({
      event: 'mylotuss_edit_profile'
    })
  }
}
